
export default {
    computed: {
        //仓库类型
        getWarehouseTypes() {
            return [
                {
                    value: '1',
                    label: 'Service Warehouse(服务仓)',
                    text: this.$t('fbb.basicdata.warehouse_type_service_remark', { defaultValue: '记录库存流水，库存根据单据产生变动' })
                },
                // {
                //     value: '2',
                //     label: this.$t('fbb.warehouse.fba_warehouse', { defaultValue: 'FBA仓'}),
                // },
                // {
                //     value: '4',
                //     label: this.$t('fbb.warehouse.onsite_warehouse', { defaultValue: 'onsite仓库'}),
                // },
                {
                    value: '5',
                    label: 'Virtual Warehouse(虚拟仓)',
                    text: this.$t('fbb.basicdata.warehouse_type_virtual_remark', { defaultValue: '记录库存流水，但可用库存及预留库存不根据单据变动' })
                },
                {
                    value: '6',
                    label: 'Transfer Warehouse(中转仓)',
                    text: null
                }
            ]
        },
        //仓库属性
        getWarehouseAttrs() {
            return [
                {
                    value: 3,
                    label: this.$t('fbb.warehouse.product_warehouse', { defaultValue: '成品仓'}),
                },
                {
                    value: 1,
                    label: this.$t('fbb.warehouse.return_warehouse', { defaultValue: '退货仓'}),
                },
                {
                    value: 4,
                    label: this.$t('fbb.warehouse.transit_warehouse', { defaultValue: '中转仓'}),
                },
                // {
                //     value: 2,
                //     label: this.$t('fbb.warehouse.maintenance_warehouse', { defaultValue: '维修仓'}),
                // }
            ]
        },
         //活动状态仓库属性
        getWarehouseActive() {
            return [
                {
                    value: null,
                    label: this.$t('global.common.all', { defaultValue: '全部'}),
                },
                {
                    value: '1',
                    label: this.$t('fbb.accountmanage.active', { defaultValue: '启用'}),
                },
                {
                    value: '0',
                    label: this.$t('fbb.accountmanage.disable', { defaultValue: '禁用'}),
                }
            ]
        },
        //仓库系统
        getWarehouseSys() {
            return [
                {
                    value: '0',
                    label: this.$t('fbb.warehouse.no_push', { defaultValue: '不推送'}),
                },
                {
                    value: '13',
                    label: this.$t('fbb.warehouse.wms', { defaultValue: 'WMS'}),
                },
                {
                    value: '15',
                    label: this.$t('fbb.warehouse.ew_wms', { defaultValue: '华美WMS'}),
                },
                /*{
                    value: '17',
                    label: this.$t('fbb.warehouse.yidayun', { defaultValue: '易达云'}),
                },*/
                {
                    value: '18',
                    label: this.$t('fbb.warehouse.mf', { defaultValue: '魔方系统'}),
                },
                {
                    value: '16',
                    label: this.$t('fbb.warehouse.yc', { defaultValue: '易仓系统'}),
                },
                {
                    value: '5',
                    label: this.$t('fbb.warehouse.hf_nc', { defaultValue: '合丰北卡'}),
                },
                {
                    value: '12',
                    label: this.$t('fbb.warehouse.jp_ht', { defaultValue: '日本海豚'}),
                },
                {
                    value: '14',
                    label: this.$t('fbb.warehouse.jf', { defaultValue: '聚丰仓库'}),
                },
                {
                    value: '19',
                    label: this.$t('fbb.warehouse.dc', { defaultValue: '懂仓'}),
                },
                {
                    value: '21',
                    label: this.$t('fbb.warehouse.jgc', { defaultValue: '骏高仓'}),
                },
                {
                    value: '22',
                    label: this.$t('fbb.warehouse.mlily', { defaultValue: 'Mlily三方仓'}),
                },
                {
                    value: '23',
                    label: this.$t('fbb.warehouse.winit', { defaultValue: '万邑通'}),
                },
                {
                    value: '25',
                    label: this.$t('fbb.warehouse.gucang', { defaultValue: '谷仓'}),
                },
                {
                    value: '27',
                    label: this.$t('fbb.warehouse.yahee', { defaultValue: 'Yahee'}),
                },
                {
                    value: '28',
                    label: 'HLV2',
                },
                {
                    value: '30',
                    label: '无忧达WMS',
                },
                {
                    value: '31',
                    label: '中景WMS',
                },
                {
                    value: '32',
                    label: '领星WMS',
                },
                {
                    value: '33',
                    label: 'YQN-WMS',
                },
                {
                    value: '34',
                    label: '大健云仓WMS',
                },
                {
                    value: '35',
                    label: '积加ERP',
                },
                {
                    value: '36',
                    label: 'SLM WMS',
                },
                {
                    value: '37',
                    label: '八爪鱼WMS',
                },
                {
                    value: '38',
                    label: '马帮ERP',
                },
                {
                    value: '39',
                    label: '大卖WMS',
                },
                {
                    value: '40',
                    label: '乐仓WMS',
                },
                {
                    value: '41',
                    label: '易仓ERP',
                },
                {
                    value: '42',
                    label: 'ShipOut WMS',
                },
                {
                    value: '43',
                    label: '电仓 WMS',
                },
                {
                    value: '44',
                    label: 'sellerclub',
                },
                {
                    value: '45',
                    label: '环世WMS',
                },
                {
                    value: '46',
                    label: '上海铁仓',
                },
                {
                    value: '47',
                    label: '易达云SASS',
                },
                {
                    value: '48',
                    label: '洋溢WMS',
                },
                {
                    value: '49',
                    label: '德威WMS',
                },
                {
                    value: '50',
                    label: '易仓OMS',
                },
                {
                    value: '51',
                    label: '西邮WMS',
                },
                {
                    value: '52',
                    label: '安美WMS',
                },
            ]
        },
    },
}
